var render, staticRenderFns
import script from "./tableForm.vue?vue&type=script&lang=js&"
export * from "./tableForm.vue?vue&type=script&lang=js&"
import style0 from "./tableForm.vue?vue&type=style&index=0&id=9d2ad58e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports